import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Receipt = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M7.807 25.706c0-.6.5-1 1-1H19c.6 0 1 .5 1 1s-.5.999-1 .999H8.806c-.5 0-1-.5-1-1ZM7.807 10.414c0-.6.5-1 1-1H35.19c.6 0 1 .5 1 1 0 .6-.5 1-1 1H8.806c-.5 0-1-.4-1-1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M42.287.42H1.71c-.6 0-1 .5-1 1v38.378c0 .3.2.6.4.8l4.898 3.597c.4.3.8.3 1.2 0l4.497-3.298 4.497 3.298c.4.3.8.3 1.2 0l4.497-3.298 4.597 3.298c.4.3.8.3 1.2 0l4.497-3.298 4.597 3.298c.4.3.8.3 1.2 0l4.897-3.598c.3-.2.4-.5.4-.8V1.42c0-.5-.4-1-1-1Zm-1 38.878-3.797 2.798-4.597-3.298c-.4-.3-.9-.3-1.2 0l-4.497 3.298-4.598-3.298c-.4-.3-.899-.3-1.199 0l-4.497 3.298-4.598-3.298c-.4-.3-.8-.3-1.199 0l-4.597 3.298-3.798-2.798V2.418h38.578v36.88Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M34.392 25.805c-.7-.5-1.6-.7-2.299-.899v-4.897c.4.1.8.3 1.2.6.6.5.899.999.899 1.698 0 .6.5 1 1 1s.999-.5.999-1c0-1.399-.8-2.598-1.7-3.298-.699-.5-1.498-.9-2.398-1v-.899c0-.6-.5-.999-1-.999-.599 0-.999.5-.999 1v.799c-2.199.4-4.097 2.099-4.097 4.398 0 .799.2 1.499.5 1.998.3.6.799 1 1.299 1.3.7.5 1.599.7 2.398.9v4.996c-1.3-.3-2.099-1.299-2.099-2.298 0-.6-.5-1-1-1-.499 0-.998.5-.998 1 0 2.298 1.898 3.997 4.097 4.397v.8c0 .6.5.999 1 .999.6 0 1-.5 1-1v-.799c2.198-.4 4.097-2.099 4.097-4.397 0-.8-.2-1.5-.5-2-.4-.699-.9-1.099-1.4-1.399Zm-4.398-1.399c-.5-.1-.9-.3-1.299-.5-.3-.2-.5-.4-.6-.6-.1-.199-.2-.499-.2-.998 0-1 .8-2 2.1-2.3v4.398Zm2.1 6.996v-4.497c.499.1.899.3 1.298.5.3.2.5.4.6.6.1.2.2.599.2 1.099 0 1-.8 1.998-2.099 2.298Z"
  })));
});
Receipt.displayName = 'Receipt';
Receipt.defaultProps = {
  'aria-label': 'Receipt'
};
export default Receipt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Receipt.js
// module id = 3890
// module chunks = 11